import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCartButton',
  props: {
    sellable: {
      type: Boolean,
      default: true
    },
    priceRegular: null,
    priceSpecial: null,
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var buttonText = computed(function () {
      return isMobile.value ? i18n.t('addToCart.addToCart') : i18n.t('addToCart.addToCartDesktop');
    });
    return {
      __sfc: true,
      props: props,
      i18n: i18n,
      isMobile: isMobile,
      buttonText: buttonText,
      AzButton: AzButton,
      AzLoader: AzLoader,
      PriceDisplay: PriceDisplay
    };
  }
});